import clsx from "clsx";
import React from "react";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];


interface Props {
  onSelectDate?: (date: Date) => void;
  className?: string;
}
const DateOptions = ({ onSelectDate, className }: Props) => {
  const getQuickSelectDates = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const thisWeekend = new Date(today);
    thisWeekend.setDate(today.getDate() + (6 - today.getDay()));

    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);

    const nextWeekend = new Date(thisWeekend);
    nextWeekend.setDate(thisWeekend.getDate() + 7);

    const twoWeeks = new Date(today);
    twoWeeks.setDate(today.getDate() + 14);

    const fourWeeks = new Date(today);
    fourWeeks.setDate(today.getDate() + 28);

    return [
      { label: "Today", date: today, shortDate: "Today" },
      {
        label: "Tomorrow",
        date: tomorrow,
        shortDate: formatDayShort(tomorrow),
      },
      {
        label: "This weekend",
        date: thisWeekend,
        shortDate: formatDayShort(thisWeekend),
      },
      { label: "Next week", date: nextWeek, shortDate: formatDate(nextWeek) },
      {
        label: "Next weekend",
        date: nextWeekend,
        shortDate: formatDate(nextWeekend),
      },
      { label: "2 weeks", date: twoWeeks, shortDate: formatDate(twoWeeks) },
      { label: "4 weeks", date: fourWeeks, shortDate: formatDate(fourWeeks) },
    ];
  };
  const formatDate = (date: Date) => {
    return date.getDate() + " " + monthNames[date.getMonth()].slice(0, 3);
  };
  const formatDayShort = (date: Date) => {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[date.getDay()];
  };
  return (
    <div
      className={clsx(
        "h-full w-[160px] flex flex-col bg-gray-400 border border-t-0 border-gray-100 py-1",
        className,
      )}
    >
      {getQuickSelectDates().map((day) => (
        <button
          key={day.label}
          type="button"
          className="flex justify-between items-center cursor-pointer hover:bg-[#E9ECF2] rounded-sm h-[32px] ps-4 pe-2"
          onClick={() => onSelectDate?.(day.date)}
        >
          <span className="text-[11px] font-medium text-[#253858]">
            {day.label}
          </span>
          <span className="text-[#79808A] text-[10px] font-normal">
            {day.shortDate}
          </span>
        </button>
      ))}
    </div>
  );
};

export default DateOptions;
